export { default } from '@/shared/components/Logo';
